module.exports = __webpack_public_path__ + "media/src/images/mypage/icon_web-799c315b469bde39e2da5974148966d7.png";